import NonInclus from '@amo/core/assets/images/icons/non_inclus.svg';
import calendarIcon from '@amo/core/assets/images/icons/calendar.svg';
import questionRetour from '@amo/core/assets/images/icons/question-retour.png';
import { useOnClickOutside } from '@amo/core/utils/hooks.js';
import { useCallback, useEffect, useRef } from 'react';
import { getTranslation } from '@amo/core/utils/functions.js';
import './popin-previous.scss';

const PopinPrevious = ({ onClose, onCallMeBack, onMakeAppointment }) => {
    const ref = useRef();
    const closeButtonRef = useRef();
    const dialogRef = useRef();

    useOnClickOutside(ref, onClose);

    useEffect(() => {
        closeButtonRef.current?.focus();
    }, []);

    useEffect(() => {
        const modal = dialogRef.current;
        if (!modal) return;

        const previouslyFocused = document.activeElement;
        const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

        const handleTab = (e) => {
            if (e.key !== 'Tab') return;
            const focusableElements = modal.querySelectorAll(focusableSelector);
            if (focusableElements.length === 0) return;
            const first = focusableElements[0];
            const last = focusableElements[focusableElements.length - 1];

            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        };

        modal.addEventListener('keydown', handleTab);
        return () => {
            modal.removeEventListener('keydown', handleTab);
            if (previouslyFocused) previouslyFocused.focus();
        };
    }, []);

    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Escape') {
            onClose();
        }
    }, [onClose]);

    return (
        <div
            className="popin-overlay"
            onKeyDown={handleKeyDown}
            ref={dialogRef}
        >
            <div
                className="popin-previous"
                ref={ref}
                role="dialog"
                aria-modal="true"
                aria-label={getTranslation('popinPrevious.title')}
            >
                <button
                    type="button"
                    ref={closeButtonRef}
                    className="popin-previous__close"
                    onClick={onClose}
                    aria-label="Fermer"
                >
                    <img src={NonInclus} alt="" aria-hidden="true" className={'close-cross-contrast'} />
                </button>

                <img src={questionRetour} alt="" aria-hidden="true" className="popin-previous__illustration" />
                <h2 className="popin-previous__title">{getTranslation('popinPrevious.title')}</h2>
                <h3 className="popin-previous__subtitle">{getTranslation('popinPrevious.subtitle')}</h3>
                <p className="popin-previous__text">{getTranslation('popinPrevious.text1')}</p>
                <p className="popin-previous__text">{getTranslation('popinPrevious.text2')}</p>

                <div className="popin-previous__actions">
                    <button
                        type="button"
                        className="btn btn-popin-filled"
                        onClick={onCallMeBack}
                    >
                        {getTranslation('popinPrevious.callMeBack')}
                    </button>
                    <button
                        type="button"
                        className="btn btn-popin-outline"
                        onClick={onMakeAppointment}
                    >
                        <img src={calendarIcon} alt="" aria-hidden="true" width={18} height={18} />
                        {getTranslation('popinPrevious.makeAppointment')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PopinPrevious;
